import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'
import CustomerOwnedRga from '~/_shared/models/CustomerOwnedRga'
import moment from 'moment'

export const state = {
  item: new CustomerOwnedRga(),
  list: [],
  total: 0,
  items: [],
  report: undefined
}

export const getters = {
  item: state => state.item,
  list: state => state.list,
  items: state => state.items,
  total: state => state.total,
  report: state => state.report
}

export const mutations = {
  ITEM (state, data) {
    state.item = Object.assign(state.item, data)
  },

  LIST (state, data) {
    state.list = data
  },

  ITEMS (state, data) {
    state.items = data
  },

  TOTAL (state, data) {
    state.total = data
  },

  REPORT (state, data) {
    state.report = data
  }
}

export const actions = {

  async fetchList ({ commit }, filterData) {
    await axios.get(laroute.route('customer_owned_rga_list', { companyAbbr: store.getters['auth/company'], ...filterData }))
      .then(response => {
        commit('LIST', response.data.items)
        commit('TOTAL', response.data.total)
      })
  },

  async create ({ commit }, formData) {
    await axios.post(laroute.route('customer_owned_rga_create', { companyAbbr: store.getters['auth/company'] }), { ...formData })
      .then(res => {
        if (res.status === 200) {
          commit('ITEM', res.data.data)
        }
      })
  },

  async getOne ({ commit }, id) {
    await axios.get(laroute.route('customer_owned_rga_get_one', { companyAbbr: store.getters['auth/company'], id }))
      .then(res => {
        res.data.data.created_at = moment(res.data.data.created_at).format('YYYY-MM-DD')
        if (res.data.data.expected_return_date) {
          res.data.data.expected_return_date = moment(res.data.data.expected_return_date).format('YYYY-MM-DD')
        }
        commit('ITEM', res.data.data)
      })
  },

  async getItems ({ commit }, id) {
    await axios.get(laroute.route('get_customer_owned_rga_items', { companyAbbr: store.getters['auth/company'], id }))
      .then(res => {
        commit('ITEMS', res.data)
      })
  },

  async getReport ({ commit }, { id, params }) {
    const { data } = await axios.post(laroute.route('customer_owned_rga_report', { companyAbbr: store.getters['auth/company'], id: id }), { params: params }, { responseType: 'arraybuffer' })
    commit('REPORT', data)
  },

  async getExcelReport ({ commit }, { id, params }) {
    const { data } = await axios.get(laroute.route('customer_owned_rga_excel_report', { companyAbbr: store.getters['auth/company'], id: id, ...params }), { responseType: 'blob' })
    commit('REPORT', data)
  },

  async delete ({ commit }, itemId) {
    await axios.delete(laroute.route('customer_owned_rga_delete', { companyAbbr: store.getters['auth/company'], id: itemId }))
  },

  async deleteExpected ({ commit }, itemId) {
    await axios.delete(laroute.route('customer_owned_rga_delete_expected_item', { companyAbbr: store.getters['auth/company'], id: itemId }))
  },

  async deleteReceived ({ commit }, itemId) {
    await axios.delete(laroute.route('customer_owned_rga_delete_received_item', { companyAbbr: store.getters['auth/company'], id: itemId }))
  },

  async addItems ({ commit }, { id, expectedItems, receivedItems }) {
    await axios.post(laroute.route('customer_owned_rga_add_items', { companyAbbr: store.getters['auth/company'], id }), { expectedItems, receivedItems })
  },

  async update ({ commit }, { id, rga, expectedItems, receivedItems }) {
    await axios.patch(laroute.route('customer_owned_rga_update', { companyAbbr: store.getters['auth/company'], id }), { rga, expectedItems, receivedItems })
  },

  async inventoryPdf ({ commit }, { params }) {
    const { data } = await axios.post(laroute.route('customer_owned_rga_inventory', { companyAbbr: store.getters['auth/company'] }), { params: params }, { responseType: 'arraybuffer' })
    commit('REPORT', data)
  },

  async inventoryExcel ({ commit }, { params }) {
    const { data } = await axios.get(laroute.route('customer_owned_rga_inventory_excel', { companyAbbr: store.getters['auth/company'], ...params }), { responseType: 'blob' })
    commit('REPORT', data)
  },

  async overviewExcel ({ commit }, { params }) {
    const { data } = await axios.get(laroute.route('customer_owned_rga_overview_excel', { companyAbbr: store.getters['auth/company'], ...params }), { responseType: 'blob' })
    commit('REPORT', data)
  },

  async createServiceSo ({ commit }, { id, rtv, forAll }) {
    await axios.post(laroute.route('customer_owned_rga_service_so_create', { companyAbbr: store.getters['auth/company'], id: id }), { rtv: rtv, forAll: forAll })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/customerOwnedRga.js